import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  syncAIPanelVisible: boolean;
}

const initialState: UIState = {
  syncAIPanelVisible: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSyncAIPanelVisible: (state, action: PayloadAction<boolean>) => {
      state.syncAIPanelVisible = action.payload;
    },
  },
});

export const { setSyncAIPanelVisible } = uiSlice.actions;
export default uiSlice.reducer;
